export default {
  creditLimit: {},
};
